module.exports = __webpack_public_path__ + "static/media/options.929028e0.svg";